export default __webpack_public_path__ + "static/media/icons-metaverses-unity.e95a39c4.svg";